
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/author",
      function () {
        return require("private-next-pages/blog/author/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/author"])
      });
    }
  